export default __webpack_public_path__ + "static/carlyhead-516f97febdcd45de57f42a10872bc30d.png";